import privateInstance from "../privateClient";
import {
  AddCustomerProfileQueryType,
  FetchCustomerProfilesSuggestionsQueryType,
} from "./types";

export const customerApi = {
  addCustomerProfile: async (params: AddCustomerProfileQueryType["Params"]) => {
    try {
      const response = await privateInstance.post<
        AddCustomerProfileQueryType["Data"]
      >("/rate-manager/customer-profiles", params);

      return response.data;
    } catch (err) {
      return null;
    }
  },

  getCustomerProfilesSuggestions: async (
    params: FetchCustomerProfilesSuggestionsQueryType["Params"],
  ) => {
    try {
      const response = await privateInstance.post<
        FetchCustomerProfilesSuggestionsQueryType["Data"]
      >("/rate-manager/list-customer-profiles-suggestions", params);

      return response.data;
    } catch (err) {
      return null;
    }
  },
};
